import { render } from "./ChildReport.vue?vue&type=template&id=3f976516&scoped=true&ts=true"
import script from "./ChildReport.vue?vue&type=script&lang=ts"
export * from "./ChildReport.vue?vue&type=script&lang=ts"

import "./ChildReport.vue?vue&type=style&index=0&id=3f976516&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f976516"]])

export default __exports__